import { IBookingCalendarStore } from '../../index'
import { IServicesAccepted } from '../../../../actions/bookingCalendar/reservationModal/servicesAccepted'

export default function(
  state: IBookingCalendarStore,
  action: IServicesAccepted,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      servicesModal: {
        ...state.reservationModal.servicesModal,
        isLoading: false,
        rates: action.rates,
        services: action.services,
      },
    },
  }
}
